import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import MuiAlert, { AlertProps as MuiAlertProps } from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

import { Icon } from '../components/Icon';

export interface AlertProps extends MuiAlertProps {
  title?: string;
}

export const Alert: React.FC<AlertProps> = ({
  children,
  sx,
  title,
  color,
  severity = 'info',
  ...otherProps
}) => {
  const iconStyles = { mt: '2px' };

  const finalColor = color || severity;

  const styles = (theme) => {
    return {
      bgcolor: `${finalColor}.lightest`,
      color: `${finalColor}.darkest`,
      '& .MuiAlert-icon': {
        color: `${finalColor}.main`,
      },
      '& .MuiAlert-action': {
        color: `${finalColor}.darkest`,
      },
      ...theme.applyStyles('dark', {
        bgcolor: `${finalColor}.darkest`,
        color: `${finalColor}.lightest`,
        '& .MuiAlert-action': {
          color: `${finalColor}.lightest`,
        },
      }),
    };
  };

  return (
    <MuiAlert
      sx={[styles, ...(Array.isArray(sx) ? sx : [sx])]}
      color={color}
      severity={severity}
      iconMapping={{
        success: (
          <Icon
            sx={iconStyles}
            icon={icon({ name: 'check-circle', style: 'regular' })}
          />
        ),
        info: (
          <Icon
            sx={iconStyles}
            icon={icon({ name: 'info-circle', style: 'regular' })}
          />
        ),
        warning: (
          <Icon
            sx={iconStyles}
            icon={icon({ name: 'exclamation-triangle', style: 'regular' })}
          />
        ),
        error: (
          <Icon
            sx={iconStyles}
            icon={icon({ name: 'exclamation-circle', style: 'regular' })}
          />
        ),
      }}
      {...otherProps}
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      {children}
    </MuiAlert>
  );
};
